import IconTextProperty from '@/features/Commons/Label/IconTextProperty';
import {
  type CATEGORY_TYPE,
  CategoryDic,
  CategoryIconDic,
} from '@/types/categoryConst';

type Props = {
  category: CATEGORY_TYPE;
  size?: 's' | 'm' | 'l';
};

const CategoryBadge = (props: Props) => {
  const Icon = CategoryIconDic[props.category];
  return (
    <IconTextProperty
      icon={<Icon />}
      value={CategoryDic[props.category]}
      size={props.size}
    />
  );
};

export default CategoryBadge;
